import { ActiveLanguage } from 'shared/vidio_helpers';
import Blocker from 'components/shared/Blocker';

export default class LoginAllaccess {
  constructor(element, currentUser) {
    this.element = element;
    this.currentUser = currentUser;
  }

  type() {
    return 'login_allaccess';
  }

  show() {
    let currentPage = new URL(window.location.href);
    currentPage.searchParams.set('t', window.contentGatingActionRequiredAfter);
    let returnLink = encodeURIComponent(currentPage.pathname+currentPage.search);
    let link = `/allaccess/login?user_return_to=${returnLink}`
    let lang = ActiveLanguage.get();
    let title = window.Locale[lang].content_gating_banner.login_allaccess.message.login_vidio;

    if(this.currentUser) {
      title = window.Locale[lang].content_gating_banner.login_allaccess.message.login_allaccess;
    }
    let buttonText = window.Locale[lang].content_gating_banner.login_allaccess.button;
    let buttons = [{
      text: buttonText,
      link: link,
      align: 'horizontal',
      theme: 'red'
    }]
    let topImageClass = 'content-gating-banner__login-allaccess-banner';
    let loginBlocker = new Blocker({element: this.element, title, buttons, topImageClass});
    loginBlocker.show();

    this.element.classList.remove('hide');
  }
}